import { SpanStatusCode, trace } from '@opentelemetry/api'

const tracer = trace.getTracer('admin-review-tool-react')

export async function withSpan<T>(spanName: string, fn: () => Promise<T>): Promise<T> {
  return tracer.startActiveSpan(spanName, async span => {
    try {
      const result = await fn()
      span.setStatus({ code: SpanStatusCode.OK })
      return result
    } catch (error) {
      span.recordException(error instanceof Error ? error : new Error(String(error)))
      span.setStatus({
        code: SpanStatusCode.ERROR,
        ...(error instanceof Error && error.message ? { message: error.message } : {})
      })
      throw error
    } finally {
      span.end()
    }
  })
}
